import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import BusinessPartnerGroupBusinessPartnerModel from '../../../models/BusinessPartnerGroupBusinessPartnerModel';
import DataService from "../../../services/data.service";
import AddBusinessPartnerPopup from '../Popups/BusinessPartnerGroup_popup_AddBusinessPartner';

interface IProps {
    businessPartnerGroupId: number
    businessPartnerTypeId: number
}

const BusinessPartnerGroup_tab_BusinessPartners: React.FC<IProps> = ({ businessPartnerGroupId, businessPartnerTypeId }) => {
    const [data, setData] = useState<BusinessPartnerGroupBusinessPartnerModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [businessPartnerGroupId]);

    function getTableData() {
        DataService.get<BusinessPartnerGroupBusinessPartnerModel[]>('api/v1/BusinessPartnerGroupBusinessPartners/ByBusinessPartnerGroup/' + businessPartnerGroupId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/BusinessPartnerGroupBusinessPartners/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'businessPartnerId', visible: false },
        { title: 'Name', dataProp: 'businessPartner', sort: 'asc' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.UpdateBusinessPartnerGroup)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtBusinessPartnerGroupBusinessPartners'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Businesspartner'
                navigateUrl='/plm/BusinessPartners/Details/'
            />
            {showPopup && <AddBusinessPartnerPopup businessPartnerGroupId={businessPartnerGroupId} businessPartnerTypeId={businessPartnerTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default BusinessPartnerGroup_tab_BusinessPartners;